import React from 'react';
import styles from './styles.module.css';

const Skeleton = () => {
  return (
    <div className={styles.skeletonWrapper}>
      <div className={styles.skeleton}></div>
    </div>
  );
};

export default Skeleton;